const $schoolIdSelect = $('#selectSchoolId');

$schoolIdSelect.change((e) => e.target.form.submit());